import fyntune from "./fyntune.png";
import Unplugged from "./Unplugged.png";
import PartnerLogin from "./PartnerLogin.png";
import Carousel from "./Carousel_image.png";
import thankyou from "./thankyou.png";
import DownloadPdf from "./DownloadPdf.jpg";
import UserProfile from "./UserProfile.jpg";
import Logout from "./Logout.png";
import navigationIcon from "./navigationIcon.jpg";
import nextStep from "./next_step.avif";
import BrokenGlass from "./BrokenGlass.jpg";
import RaiseClaim from "./RaiseClaims.jpg";
import RaiseClaimIpOpd from "./claimsIpOpd.png";
const Images = {
  fyntune,
  Unplugged,
  PartnerLogin,
  Carousel,
  thankyou,
  DownloadPdf,
  UserProfile,
  Logout,
  navigationIcon,
  nextStep,
  BrokenGlass,
  RaiseClaim,
  RaiseClaimIpOpd,
};
export default Images;
